import React from "react";

export default function ViewStaffModal({ staff, onClose }) {
  if (!staff) return null;
  const rows = [
    ["Name", staff.name || staff.username || "—"],
    ["Email", staff.email || "—"],
    ["Mobile", staff.mobile || "—"],
    ["Role", staff.role ? staff.role.charAt(0).toUpperCase() + staff.role.slice(1) : "—"],
    ["Joining Date", staff.joiningDate || "—"],
    ["Leaving Date", staff.leavingDate || "—"],
    ["Status", staff.status === "inactive" ? "Inactive" : "Active"],
    ["Authentication UID", staff.id],
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-xl font-semibold">Staff Details</h2>
          <button onClick={onClose} className="text-gray-500 text-2xl">×</button>
        </div>
        <div className="p-6 space-y-3">
          {rows.map(([label, value]) => (
            <div key={label} className="grid grid-cols-3 gap-3 border-b pb-2">
              <div className="text-sm font-medium text-gray-600">{label}</div>
              <div className="col-span-2 text-sm break-all">{value}</div>
            </div>
          ))}
        </div>
        <div className="px-6 py-4 border-t flex justify-end">
          <button onClick={onClose} className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-black">Close</button>
        </div>
      </div>
    </div>
  );
}
